module.exports = __webpack_public_path__ + "img/white.fba4982a.png";